import { environment } from '../internal'

export const devLogger = (msg: any) => {
  if (environment === 'development') {
    // tslint: disable 
    console.warn(msg);
  }
}